import type { MouseEvent, ReactNode } from 'react';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import {
  IconButton,
  ListItem,
  ListItemButton,
  ListItemText,
  listItemButtonClasses,
  listItemSecondaryActionClasses,
} from '@mui/material';

export interface SelectableListItemProps {
  title: string;
  secondary?: ReactNode;
  leading?: ReactNode;
  selected?: boolean;
  onClick?: () => void;
  onMenuClick?: (event: MouseEvent<HTMLElement>) => void;
}

const action = `.${listItemSecondaryActionClasses.root}`;

const SelectableListItem = ({
  title,
  secondary,
  leading,
  selected = false,
  onClick,
  onMenuClick,
}: SelectableListItemProps) => (
  <ListItem
    component="div"
    disablePadding
    secondaryAction={
      onMenuClick ? (
        <IconButton
          size="small"
          aria-label={`${title} options`}
          onClick={onMenuClick}
        >
          <MoreVertIcon fontSize="small" />
        </IconButton>
      ) : undefined
    }
    sx={{
      mb: 0.25,
      [`& > .${listItemButtonClasses.root}`]: { pr: onMenuClick ? 5 : 0.5 },
      [`& ${action}`]: { right: 4, opacity: 0 },
      [`&:hover ${action}, &:focus-within ${action}`]: { opacity: 1 },
      '@media (hover: none)': { [`& ${action}`]: { opacity: 1 } },
    }}
  >
    <ListItemButton
      selected={selected}
      onClick={onClick}
      sx={{ gap: 0.5, px: 0.5, py: 0.75, borderRadius: 1.5 }}
    >
      {leading}
      <ListItemText
        primary={title}
        secondary={secondary}
        sx={{ my: 0, minWidth: 0 }}
        slotProps={{
          primary: {
            variant: 'body2',
            fontWeight: selected ? 600 : 500,
            noWrap: true,
          },
          secondary: { component: 'div', sx: { mt: 0.25 } },
        }}
      />
    </ListItemButton>
  </ListItem>
);

export default SelectableListItem;
